<template>
	<!-- BEGIN register -->
	<div class="register register-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image"><img src="./../images/rejectbg.jpg" alt="" style="width: 100%;height: 100%;" /></div>
			<div class="news-caption"><h4 class="caption-title">湖南高铁时代综合实训管理平台</h4></div>
		</div>
		<!-- END news-feed -->

		<!-- BEGIN register-container -->
		<div class="register-container" style="padding: 55px;">
			<!-- BEGIN register-header -->
			<div class="register-header mb-25px h1">
				<div class="mb-1">注册</div>
				<small class="d-block fs-15px lh-16">创建您的账户，他是免费的，永远都是.</small>
			</div>
			<!-- END register-header -->

			<!-- BEGIN register-content -->
			<div class="register-content" style="">
				<form method="POST" class="fs-13px">
					<div class="mb-3">
						<label class="mb-2">
							所属地区
							<span class="text-danger">*</span>
							<span v-if="isschoolsdiz" style="color: red;margin-left: 1rem;">请选择所属地区</span>
						</label>
						<select @change="changeschooldiz()" v-model="users.AI_ProvinceId" class="sleted fs-13px" id="exampleFormControlSelect1">
							<option value="">-- 请选择所属省份 --</option>
							<option v-for="(item, index) in schooldiz" :key="index" :label="item.si_name_cn" :value="item.Id">{{ item.Name }}</option>
						</select>
					</div>

					<div class="mb-3">
						<label class="mb-2">
							所在学校
							<span class="text-danger">*</span>
							<span v-if="isschools" style="color: red;margin-left: 1rem;">请选择学校</span>
						</label>

						<select
							@change="scoolchanges()"
							class="sleted fs-13px"
							:style="{ 'border-color': isschools ? 'red' : '' }"
							style="border-radius: 5px;"
							v-model="users.school"
						>
							<option value="请选择学校">请选择学校</option>
							<option v-for="(item, index) in schoollist" :key="index" :value="item.si_guid">{{ item.si_name_cn }}</option>
						</select>
					</div>

					
					 <div class="mb-3">
					 	<label class="mb-2">
					 		所在专业
					 		<!-- <span class="text-danger">*</span> -->
					 		<!-- <span v-if="ispros" style="color: red;margin-left: 1rem;">请选择专业</span> -->
					 	</label>
						<!-- :style="{ 'border-color': ispros ? 'red' : '' }"  -->
					 	<select @change="proschanges()"
					 	 class="sleted fs-13px"
					 	  style="border-radius: 5px;" v-model="users.proids">
					 		<option value="">请选择专业</option>
					 		<option v-for="(item, index) in prosllist" :key="index" :value="item.pro_guid">{{ item.pro_name }}</option>
					 	</select>
					 </div>
					 
					 <div class="mb-3">
						<label class="mb-2">
							所在班级
							<!-- <span class="text-danger">*</span> -->
							<!-- <span v-if="isclas" style="color: red;margin-left: 1rem;">请选择班级</span> -->
						</label>
						<!-- :style="{ 'border-color': isclas ? 'red' : '' }"  -->
						<select @change="claschanges()" class="sleted fs-13px" style="border-radius: 5px;" v-model="users.clasids">
							<option value="">请选择班级</option>
							<option v-for="(item, index) in clasllist" :key="index" :value="item.cla_guid">{{ item.cla_name }}</option>
						</select>
					</div>

					<div class="mb-3">
						<label class="mb-2">
							用户名
							<span class="text-danger">*</span>
							<span class="mb-2" style="color: #B0171F;margin-left: 0.5rem;display: inline;" v-if="usershow == 1">
								请输入4-16位的用户名,可以使字母,数组,特殊字符,字符串
							</span>
						</label>
						<input
							@input="changetextusername(1)"
							@change="getvalidatemzm()"
							v-model="users.username"
							type="text"
							:style="{ 'border-color': usershow == 1 ? 'red' : '' }"
							style="color: #000;"
							class="form-control fs-13px"
							placeholder="请输入用户名"
							maxlength="16"
						/>
					</div>

					<div class="mb-3">
						<label class="mb-2">
							手机号码
							<span class="text-danger">*</span>
							<span class="mb-2" style="color: #B0171F;margin-left: 0.5rem;display: inline;" v-if="usershow == 8">请输入正确手机号码</span>
						</label>
						<!--  -->
						<input
							@input="changetextphone(8)"
							v-model="users.userphone"
							type="text"
							style="color: #000;"
							maxlength="11"
							:style="{ 'border-color': usershow == 8 ? 'red' : '' }"
							class="form-control fs-13px"
							placeholder="请输入手机号码"
						/>
					</div>
					<div class="mb-4">
						<label class="mb-2">
							密码
							<span class="text-danger">*</span>
							<span class="mb-2" style="color: #B0171F;margin-left: 0.5rem;display: inline;" v-if="usertextshow == 2">请输入6-16位的密码,必须是字母与数字</span>
						</label>
						<input
							@input="changetextpassword(2)"
							style="color: #000;"
							v-model="users.password"
							type="password"
							:style="{ 'border-color': usertextshow == 2 ? 'red' : '' }"
							class="form-control fs-13px"
							placeholder="请输入密码"
						/>
						<i class="iconshow" @click="flags = !flags" :class="users.ui_password ? elIcons : ''"></i>
						<!-- <span class="mb-2" style="color: #bcbcbc;margin: 10px 0;display: block;"
                            v-show="usershow==12">请输入正确的密码</span> -->
					</div>
					<div class="mb-4">
						<label class="mb-2">
							再次输入密码
							<span class="text-danger">*</span>
							<span class="mb-2" style="color: red;margin-left: 0.5rem;display: inline;" v-if="usershow == 3">请输入相同的密码</span>
						</label>
						<input
							@input="changetextpasswordtoo(3)"
							style="color: #000;"
							v-model="users.passwordtoo"
							type="password"
							:style="{ 'border-color': usershow == 3 ? 'red' : '' }"
							class="form-control fs-13px"
							placeholder="请再次输入密码"
						/>
					</div>
					<div class="mb-3">
						<label class="mb-2">
							邮箱地址
							<!-- <span class="text-danger">*</span> -->
							<span class="mb-2" style="color: red;margin-left: 0.5rem;display: inline;" v-if="usershow == 4">请输入邮箱或者邮箱输入错误</span>
						</label>
						<!--  -->
						<input
							@input="changetext(4)"
							style="color: #000;"
							v-model="users.Emai"
							type="text"
							:style="{ 'border-color': usershow == 4 ? 'red' : '' }"
							class="form-control fs-13px"
							placeholder="请输入邮箱地址"
						/>
					</div>
					<div class="mb-2">
						<label class="mb-2">
							验证码
							<span class="text-danger">*</span>
							<span class="mb-2" style="color: #ccc;margin-left: 0.5rem;display: inline;" v-if="usershow == 11">请输入正确的验证码</span>
						</label>
						<div class="row gx-3">
							<div class="col-md-8 mb-2 mb-md-0">
								<input
									v-model="users.identifying"
									style="color: #000;"
									type="text"
									:style="{ 'border-color': usershow == 11 ? 'red' : '' }"
									class="form-control fs-13px"
									placeholder="请输入验证码"
								/>
							</div>
							<div class="col-md-4" @click="getvalidatemzm()" v-loading="loadings" style="overflow: hidden;" v-if="imgshow">
								<el-skeleton style="width: auto;margin-top: -3px;" :loading="loading" animated>
									<template slot="template">
										<el-skeleton-item variant="image" style="width: auto; height: 2.4rem;" />
									</template>
									<template>
										<img class="image" :src="images == '' ? './../images/yzm.svg' : images" alt="" style="width: 100%;margin: 0.2rem 0rem;height: 2.3rem;" />
									</template>
								</el-skeleton>
							</div>
						</div>
					</div>

					<!-- <div class="form-check mb-4">
                        <input v-model="checkuser" class="form-check-input" type="checkbox" value=""
                            id="agreementCheckbox" />
                        <label class="form-check-label" for="agreementCheckbox">
                            勾选按钮代表同意 <a href="javascript:;">用户协议</a> 和
                            已阅读<a href="javascript:;">使用协议</a>, 以及 <a href="javascript:;">存储用户信息
                            </a>.
                        </label>
                    </div> -->
					<div class="mb-4 mt-4">
						<button type="button" class="btn btn-primary d-block w-100 btn-lg h-45px fs-13px" @click="registers()" v-preventReClick>立即注册</button>
					</div>
					<div class="mb-4 pb-5" style="width: 100%;text-align: right;">
						已有帐号?
						<router-link to="/user/logins">马上登录</router-link>
					</div>
					<hr class="bg-gray-600 opacity-2" />
					<p class="text-center text-gray-600">&copy; 实训后台管理系统 {{ new Date().getFullYear() }}</p>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import AppOptions from '../config/AppOptions.vue';
import { register, SchoolGetRegSchoolList } from '@/request/api/login/login.js';

import { validatem, GetPublicProfList, GetPublicProClassList } from '@/request/alllog.js';

import { GetProvinceListSchool, GetRegSchoolListSchool } from '@/request/api/mange/mange.js';

import { setbaseurl } from '@/utils/utils';

export default {
	data() {
		return {
			flags: false,
			imgshow: false,
			// 骨架屏loading值
			loading: true,
			loadings: false,
			isschoolsdiz: false,
			// 注册用户
			users: {
				school: '请选择学校',
				username: '',
				password: '',
				passwordtoo: '',
				Emai: '',
				identifying: '',
				userphone: '',
				AI_ProvinceId: '',
				proids: '',
				clasids: ''
			},
			isclas: false,
			clasllist: [],
			ispros: false,
			prosllist: [],
			schoollist: [],
			// 控制提示符
			usershow: 0,
			usertextshow: 0,
			// 用户协议
			checkuser: false,
			images: '',
			isschools: false,
			schooldiz: []
		};
	},
	created() {
		AppOptions.appEmpty = true;
	},
	beforeMount() {
		GetProvinceListSchool().then(res => {
			this.schooldiz = res.data.data;
		});
	},
	computed: {
		type() {
			return this.flags ? 'text' : 'password';
		},
		elIcons() {
			return this.flags ? 'el-icon-view' : 'fa fa-eye-slash';
		}
	},
	mounted() {
		// SchoolGetRegSchoolList().then(res => {
		//     console.log(res)
		//     this.schoollist = res.data.data
		// })
	},
	updated() {
		// console.log(this.users)
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	},
	methods: {
		//校验用户名是否为中文
		onIptCN() {
			var pattern = new RegExp('[\u4E00-\u9FA5]+');
			if (!pattern.test(this.users.username)) {
				// this.$message({
				// 	message: '请输入正确的中文名'
				// });
				return;
			}
		},
		changeschooldiz() {
			this.users.school = '请选择学校';
			this.schoollist = [];
			this.users.clasids = '';
			this.clasllist = [];
			this.prosllist = [];
			this.users.proids = '';

			if (this.users.AI_ProvinceId !== '') {
				this.isschoolsdiz = false;
			}
			GetRegSchoolListSchool(this.users.AI_ProvinceId).then(res => {
				this.schoollist = res.data.data;
			});
		},
		// 判断输入字符串是否为空或者全部都是空格
		isNull(str) {
			if (str == '') return true;
			var regu = '^[ ]+$';
			var re = new RegExp(regu);
			return re.test(str);
		},
		// 学校发生改变值为false
		scoolchanges() {
			this.users.clasids = '';
			this.clasllist = [];
			this.prosllist = [];
			this.users.proids = '';

			if (this.users.school == '请选择学校') {
				this.isschools = true;
			} else {
				this.isschools = false;
				GetPublicProfList(this.users.school).then(res => {
					// console.log(res,"获取专业")
					if (res.data.code > 0) {
						this.prosllist = res.data.data;
					}
				});
			}
		},
		proschanges() {
			this.users.clasids = '';
			this.clasllist = [];

			if (this.users.proids == '') {
				this.ispros = true;
			} else {
				this.ispros = false;
				let plproguid = {
					si_guid: this.users.school,
					pro_guid: this.users.proids
				};
				GetPublicProClassList(plproguid).then(res => {
					// console.log('获取班级', res.data);
					if (res.data.code > 0) {
						this.clasllist = res.data.data;
					}
				});
			}
		},
		claschanges() {
			if (this.users.clasids == '') {
				this.isclas = true;
			} else {
				this.isclas = false;
				console.log('班级修改');
			}
		},

		// 获取验证码
		getvalidatemzm() {
			this.loadings = true;
			// console.log(this.users.username)
			let username = this.users.username;
			if (this.isNull(username)) {
				// this.$message.warning("用户名不能全输入空格")
				// console.log('进入错误提示');
				this.usershow = 1;
			} else {
				setTimeout(() => {
					this.loadings = false;
					this.loading = false;
					validatem(username).then(res => {
						var date = new Date().getTime();
						this.imgshow = true;
						// console.log(res);
						this.images = window.myURL.URL + '/user/GetQrCode?ui_userName=' + username + '&t=' + date;
					});
				}, 2000);
			}
		},

		// 立即注册
		registers() {
			if (this.users.AI_ProvinceId == '') {
				this.isschoolsdiz = true;
				return;
			}
			if (this.users.school == '请选择学校') {
				this.isschools = true;
				return;
			}

			// users.proids
			// users.clasids

			// if (this.users.proids == '') {
			// 	this.ispros = true;
			// 	return;
			// }

			// if (this.users.clasids == '') {
			// 	this.isclas = true;
			// 	return;
			// }

			if (this.users.username.length == 0 || this.usershow == 1) {
				this.usershow = 1;
				return;
				// console.log("用户名未输入")
			}
			if (this.users.userphone.length == 0 || this.users.userphone.length < 11) {
				this.usershow = 8;
				this.$message({
					message: '请输入正确的电话号码'
				});
				return;
				// console.log("电话号码")
			}
			if (this.users.password.length == 0 || this.usertextshow == 2) {
				this.usershow = 2;
				this.$message({
					message: '请输入正确的密码'
				});
				return;
			}
			if (this.users.passwordtoo.length == 0 || this.usershow == 3) {
				this.usershow = 3;
				this.$message({
					message: '请输入正确的密码，且与输入的密码相同'
				});
				return;
			}
			// if (this.users.Emai.length == 0 || this.usershow == 4) {
			// 	this.usershow = 4;
			// 	this.$message({
			// 		message: '请输入正确的邮箱'
			// 	});
			// 	return;
			// }

			if (this.users.identifying.length == 0) {
				this.usershow = 11;
				return;
			}

			let userreg = {
				ui_userName: this.users.username,
				ui_password1: this.users.password,
				ui_password2: this.users.passwordtoo,
				ui_email: this.users.Emai,
				si_guid: this.users.school,
				ui_mobile: this.users.userphone,
				qrcode: this.users.identifying
			};
			// cla_guid: this.users.clasids

			register(userreg).then(res => {
				// console.log(res, '注册');
				if (res.data.code == 1) {
					this.$message({
						message: '恭喜你注册成功！！！3秒后前往登录页面',
						type: 'success'
					});
					let that = this;
					this.$cookie.set('/%password/%', this.users.password);
					this.$cookie.set('/%name/%', this.users.username);
					setTimeout(() => {
						that.$router.push({
							path: '/user/logins'
						});
					}, 3000);
					this.users = {};
					this.users.school = '';
				}
			});
		},
		// 用户名
		changetextusername() {
			/* console.log(this.users.username.length);
            console.log('' + this.users.username.length > 4); */
			var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
			var re = new RegExp(reg);
			var specials = new RegExp(specials);
			// console.log(this.users.username.length >= 4,this.users.username.length > 0 && this.users.username.length < 4)
			if (this.users.username.length > 0 && this.users.username.length < 4) {
				this.usershow = 1;
			}
			// if (specials.test(this.users.username)) {
			// 	this.usershow = 1;
			// }
			if (this.users.username.length >= 4) {
				this.usershow = 0;
			}
		},
		// 手机号码
		changetextphone() {
			var special = /[`~,.<>;':"\/\[\]\|{}()=_+-]/;
			var specials = new RegExp(specials);
			var rege8 = /^1[3456789]\d{9}$/;
			var resm8 = new RegExp(rege8);
			// console.log(resm8.test(this.users.userphone), specials.test(this.users.userphone));
			if (resm8.test(this.users.userphone) && specials.test(this.users.userphone)) {
				this.usershow = 0;
			} else {
				this.usershow = 8;
			}
		},
		// 密码
		changetextpassword() {
			// console.log("到密码了")
			let pas = this.users.password;
			var special = /[`~,.<>;':"\/\[\]\|{}()=_+-]/;
			var specials = new RegExp(specials);
			// this.usershow = 0;
			var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
			var re = new RegExp(reg);

			if (pas.length > 0 && pas.length < 8) {
				// console.log("进入不满足条件")
				// console.log(re.test(pas))
				this.usertextshow = 2;
			}
			if (specials.test(pas)) {
				this.usertextshow = 2;
			}
			if (pas.length >= 6) {
				// console.log("进入满足条件")
				if (re.test(pas)) {
					// console.log(pas)
					this.usertextshow = 0;
				}
			}
		},
		// 再次输入密码
		changetextpasswordtoo() {
			let pas = this.users.password;
			var special = /[`~,.<>;':"\/\[\]\|{}()=_+-]/;
			var specials = new RegExp(specials);
			// this.usershow = 0;
			var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
			var re = new RegExp(reg);
			console.log(specials.test(this.users.passwordtoo), pas == this.users.passwordtoo);
			if (specials.test(this.users.passwordtoo) && pas == this.users.passwordtoo) {
				this.usershow = 0;
			} else {
				this.usershow = 3;
			}
		},

		// 当input聚焦是显示对应的值
		changetext(i) {
			// console.log(i)
			let pas = this.users.password;
			var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
			var re = new RegExp(reg);
			var special = /[`~,.<>;':"\/\[\]\|{}()=_+-]/;
			var specials = new RegExp(specials);

			// //邮箱
			if (i == 4) {
				var rege = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;
				var resm = new RegExp(rege);
				if (resm.test(this.users.Emai) && specials.test(this.users.Emai)) {
					this.usershow = 0;
				} else {
					this.usershow = 4;
				}
			}
		}
	}
};
</script>

<style scoped>
.form-control {
	color: #000 !important;
}

.iconshow {
	position: absolute;
	display: block;
	color: #ccc;
	font-size: 1rem;
	width: 1vw;
	height: 1vw;
	top: 40%;
	right: 6%;
}

.registerselect option {
	color: #ccc;
}

.sleted {
	outline: 0 #ced4da;
	display: block;
	width: 100%;
	padding: 0.4375rem 0.75rem;
	font-size: 0.75rem;
	font-weight: 600;
	line-height: 1.5;
	/* color: var(--app-component-color); */
	color: #4c3e3e;
	background-color: var(--app-component-bg);
	background-clip: padding-box;
	border: 1px solid #ced4da;
}
</style>
